import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const macroCalculatorTool: Tool = {
  id: "macro-calculator",
  name: () => m.macro_tool_name(),
  description: () => m.macro_tool_description(),
  icon: "🍗",
  basePath: "/macro-calculator",
  status: "stable",
  tags: ["health", "fitness", "calculator", "macro-calculator"],
};
